import { render, staticRenderFns } from "./phoneHistoryAssess.vue?vue&type=template&id=40a2630f&scoped=true"
import script from "./phoneHistoryAssess.vue?vue&type=script&lang=js"
export * from "./phoneHistoryAssess.vue?vue&type=script&lang=js"
import style0 from "./phoneHistoryAssess.vue?vue&type=style&index=0&id=40a2630f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2630f",
  null
  
)

export default component.exports